export enum ESettingsGroup {
  GENERAL = 'General',
  WIDGETS = 'Widgets',
}
